import { el } from 'redom';

import './index.scss';

class ConfirmationPrompt {

  constructor(configuration) {

    this.header = configuration.header;
    this.description = configuration.description;
    this.confirmButtonText = configuration.confirmButtonText;
    this.cancelButtonText = configuration.cancelButtonText;
    this.onConfirm = configuration.onConfirm;
    this.onCancel = configuration.onCancel;

    this.el = el('.confirmation-prompt-main', [
      el('.body-section', [
        el('h2.dialog-header-text', this.header),
        el('p.field-label', this.description),
      ]),
      el('div.button-container',
        el('button.delete-button.cancel-button', {
          onclick: this.handleCancelButtonClick.bind(this)
        }, this.cancelButtonText),
        el('button.startup-themed-button.confirm-button', {
          onclick: this.handleConfirmButtonClick.bind(this)
        }, this.confirmButtonText))
    ]);

  }

  handleCancelButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.onCancel();

  }

  handleConfirmButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.onConfirm();

  }

}

export default ConfirmationPrompt;